import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const customerDetailApi = createApi({
  reducerPath: 'customerDetailApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['customerDetail'],
  endpoints: (builder) => ({
    getAllCustomerDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.customerDetailController.getAllCustomerDetail}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteCustomerDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.customerDetailController.deleteCustomerDetail}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    saveCustomerDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.customerDetailController.saveCustomerDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateCustomerDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.customerDetailController.updateCustomerDetail,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    uploadCustomerImage: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.customerDetailController.uploadCustomerImage}${body.id}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    findCustomerDetailById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.customerDetailController.findCustomerDetailById}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllCustomerDetailMutation,
  useDeleteCustomerDetailMutation,
  useSaveCustomerDetailMutation,
  useUpdateCustomerDetailMutation,
  useUploadCustomerImageMutation,
  useFindCustomerDetailByIdMutation,
} = customerDetailApi;
